/**
 * Created by Ray on 2017/11/6.
 */

import { Injectable } from '@angular/core';
import {Observable} from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import {MessageService} from 'primeng/api';

@Injectable()
export class MsgService {
    constructor(private messageService: MessageService){}

    showSuccess(title, msg) {
        this.clear();
        this.addGlobalMsg('success', title, msg);
    }

    showInfo(title, msg) {
        this.clear();
        this.addGlobalMsg('info', title, msg);
    }

    showWarn(title, msg) {
        this.clear();
        this.addGlobalMsg('warn', title, msg);
    }

    showError(title, msg) {
        this.clear();
        this.addGlobalMsg('error', title, msg);
    }

    addGlobalMsg(severity, summary, detail){
        this.messageService.add({key:'global', severity:severity, summary:summary, detail:detail});
    }

    clear() {
        this.messageService.clear('global');
    }
}



// WEBPACK FOOTER //
// C:/Projects/ServiceChain/servicechain2/svc-ui/TRUNK/src/app/shared/service/message.service.ts